import type { MetricRecordData } from "@/types/metrics/contracts"

import { isEnabledAutomaticExpectedBehaviorMetric } from "../configuration/utils/isExpectedBehaviorCompositeMetric"

interface ExpectedBehaviorCase {
  expected_behaviors?: string[] | null
  test_case_description?: string | null
  test_set_row_id?: string | null
  metric_outputs?: Record<string, { error_status?: string | null }>
}

export function getSkippedExpectedBehaviorMessage(
  metric: {
    id: string
    metric_metadata?: MetricRecordData["metric_metadata"] | null
  },
  rows: ExpectedBehaviorCase[],
): string | null {
  if (!isEnabledAutomaticExpectedBehaviorMetric(metric)) {
    return null
  }
  const hasOnlyEmptyCases =
    rows.length > 0 &&
    rows.every(
      (row) =>
        row.metric_outputs?.[metric.id]?.error_status === "SKIPPED" &&
        Array.isArray(row.expected_behaviors) &&
        !row.expected_behaviors.some((criterion) => criterion.trim()),
    )
  return hasOnlyEmptyCases ? "No expected behaviors set for test case." : null
}
